/**
 * Angular imports.
 */
import { Component, OnInit, Input, OnDestroy } from '@angular/core';

/**
 * Service imports.
 */
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { PostApiService } from '../../../dataservices/post-api.service';
import { FunCollectionService } from '../../common-functions/fun-collection.service';
import { MultiLangService } from '../../../dataservices/master-service/multi-lang.service';
import { JwtDecodeService } from '../../../dataservices/jwt-decode.service';
import { OnboardingService } from '../../../dataservices/onboarding/onboarding.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';
import { ENTRY, EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';
import { ACTION_ON, ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from 'src/app/constants/app.constants';


/**
 * Association Verification Modal.
 */
@Component({
  selector: 'app-association-verification-modal',
  templateUrl: './association-verification-modal.component.html',
  styleUrls: ['./association-verification-modal.component.scss']
})
export class AssociationVerificationModalComponent implements OnInit, OnDestroy {

  @Input() data;
  @Input() callingfrom;
  public errObj = [];
  public infomrn = false;
  public inputData = [];
  public err_msg = '';
  public hasChanged = false;
  public displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public config: any;
  public api_in_process = false;
  public showColor = false;

  /**
   * START TIME
   */
  private startTime = 0;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();


  /**
   * Necessary instance.
   */
  constructor(
    public dss: DataStorageService,
    private masterSer: MasterserviceService,
    private postApiSer: PostApiService,
    private fcs: FunCollectionService,
    public multiLangService: MultiLangService,
    private jwtSer: JwtDecodeService,
    private onboardingService: OnboardingService,
    public mls: NewLanguageService,
    private analyticSdk: Analytics
  ) { }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    const entryData: ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.OTHER,
      entity_code: 0,
      source: this.fcs.currentScreename,
      current_screen_name: SCREEN_NAME.VERIFICATION_DOCUMENT,
      start_time: this.startTime = new Date().getTime()
    };
    this.analyticSdk.analyticService.ENTRY(entryData);
    setTimeout(() => {
      if (this.callingfrom != 'resubmit') {
        sessionStorage.setItem('resub', JSON.stringify(this.data));
      } else {
        if (sessionStorage.getItem('resub') != null) {
          this.data = JSON.parse(sessionStorage.getItem('resub'));
        }
      }
    }, 500);
  }

  /**
   * go Back
   */
  goBack(backStatus): void {
    const showstatus = (backStatus == 1) ? true : false;
    const displayObj = {
      isShow: showstatus,
      display_section: 'verify_step1',
      data: []
    };
    this.masterSer.showWebModal.next(displayObj);
  }

  /**
   * user Input
   */
  userInput(data): void {
    this.errObj = [];
    this.err_msg = '';
    let i = 0;
    for (; i < this.inputData.length; i++) {
      if (this.inputData[i].log_id == data.log_id) {
        break;
      }
    }
    this.inputData.splice(i, 1);
    if (data.value != '' || data.doc_url != '') {
      this.inputData.push(data);

    }
    if (this.inputData.length > 0) {
      this.showColor = true;
    } else {
      this.showColor = false;
    }
  }

  /**
   * submit Doc
   */
  submitDoc(): boolean {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.OTHER, 0, SCREEN_NAME.VERIFICATION_DOCUMENT, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.MRN_ID_NEXT, null);
    if (this.inputData.length == 0) {
      this.err_msg = 'please provide require information';
      return;
    } else {
      let validateArrData = [];
      for (let i = 0; i < this.inputData.length; i++) {
        validateArrData = this.data.user_doc_list.filter(x => x.log_id == this.inputData[i].log_id && x.log_id != 0);
      }

      for (let i = 0; i < validateArrData.length; i++) {
        if (validateArrData[i].log_id == this.inputData[i].log_id) {
          if (validateArrData[i].required_details.is_document_required == 1 && this.inputData[i].doc_url == '') {
            const temp = { log_id: this.inputData[i].log_id, err_msg: 'please provide document' };
            this.errObj.push(temp);
          }
        }
      }
      if (this.errObj.length > 0) {
        this.hasChanged = !this.hasChanged;
        return false;
      }

      this.api_in_process = true;
      let country_id = '';
      if (this.onboardingService.ddl_data.selected_data.length > 0) {
        country_id = this.onboardingService.ddl_data.selected_data[0].id;
      } else {
        country_id = this.dss.user_profile_data.profile.country_id;
      }

      this.subscriptions.add(this.postApiSer.verificationSubmitDoc(this.inputData, country_id).subscribe(resData => {
        this.jwtSer.decodeData(resData).then(data => {
          this.api_in_process = false;
          if (data['status'] == 1) {
            if (data['code'] == 2000) {
              this.dss.user_profile_data.profile.mrn = this.inputData[0].value;
              this.displayObj.isShow = true;
              this.displayObj.display_section = 'verificationSuccess';
              this.displayObj.data = data['data'];
              this.displayObj.errObj = [];
              this.masterSer.showWebModal.next(this.displayObj);
            }
          } else {
            this.api_in_process = false;
            this.fcs.errorHandeler(data);
          }
        }, () => {
          this.api_in_process = false;
        });
      }));
    }
  }
  /**
   * uploading document event
   */
  fileUpload(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.OTHER, 0, SCREEN_NAME.VERIFICATION_DOCUMENT, CTA_TYPE.BUTTON,ACTION_TYPE.CLICK,ACTION_ON.UPLOAD_MRN_ID, null);
  }
    /**
   * uploading document event
   */
  mrnFocus(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.OTHER, 0, SCREEN_NAME.VERIFICATION_DOCUMENT, CTA_TYPE.TEXT_INPUT_AREA,ACTION_TYPE.CLICK,ACTION_ON.INPUT_MRN_ID, null);
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    const exitData: EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.OTHER,
      entity_code: 0,
      current_screen_name: SCREEN_NAME.VERIFICATION_DOCUMENT,
      start_time: this.startTime,
      end_time: new Date().getTime()
    };
    this.analyticSdk.analyticService.EXIT(exitData);
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
